import { ReportsTopBarActions, ReportsView } from '@elva/ui';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

export function ReportsPage() {
  usePageTopBar({
    actions: <ReportsTopBarActions />,
  });

  return (
    <div className="-m-6 flex min-h-full flex-1">
      <ReportsView />
    </div>
  );
}
